import React from 'react';

export default () => (
  <div className="App">
    <div>
      <div>
        <div>Info About Garden.</div>
      </div>
    </div>
  </div>
);


// WEBPACK FOOTER //
// ./src/routes/Info.js